export enum ButtonClicked {
    Cancel = 0,
    Ok = 1,
    Alt1 = 2,
}
